/* eslint-disable */
import React, { useEffect, useRef, useState } from 'react'
import Payment, { SdkMessage, MessageType, ClientSdkInstance } from '@solidgate/react-sdk'
import { createSolidGatePaymentIntent } from '@/helpers/solidGateHelpers'
import { PaymentPlan } from '@/types/types'
import { cn } from '@/lib/utils'
import {
    clickPurchaseButton,
    trackLoadedApplePay,
    trackPayment,
    trackPaymentErrors,
} from '@/helpers/facebookPixelEvents'

interface PaymentFormInterface {
    plan: PaymentPlan
    email: string
    onSuccess: (val: boolean) => void
    handleLoading: (val: boolean) => void
    version?: string
}

export const PaymentForm = (props: PaymentFormInterface) => {
    const [merchantData, setMerchantData] = useState()
    const [isFailedPayment, setIsFailedPayment] = useState(false)
    const [paymentError, setPaymentError] = useState('')
    const theme = localStorage.getItem('data-theme') ?? 'dark'
    const mainColor = '#101A36B2'
    const borderColor = theme === 'dark' ? '#d2d2d2' : '#333a4933'
    const trafficSource = localStorage.getItem('trafficSource') ?? ''
    const appleContainerRef = useRef(null)

    const handleCreatePaymentIntent = () => {
        createSolidGatePaymentIntent({
            email: props.email,
            productId: props.plan.solidGateProductID ?? '',
            failUrl: `${window.location.origin}/fail-payment`,
            trafficSource
        }).then((res) => {
            setMerchantData(res)
            trackPayment('SolidGateInit', 'true')
            setIsFailedPayment(false)
        })
    }

    useEffect(() => {
        handleCreatePaymentIntent()
    }, [props.plan])

    useEffect(() => {
        trackLoadedApplePay()
    }, [])

    useEffect(() => {
        if (!isFailedPayment) {
            handleCreatePaymentIntent()
        }
    }, [isFailedPayment])

    const handleOnError = (e: SdkMessage[MessageType.Error]) => {
        trackPaymentErrors('SolidGateError', e)
    }

    const handleOnFail = (e: SdkMessage[MessageType.Fail]) => {
        setIsFailedPayment(true)
        trackPaymentErrors('SolidGateFail', e.message)
        setPaymentError(e.message ?? '')
    }

    const handleOnMounted = (e: SdkMessage[MessageType.Mounted]) => {
        setTimeout(() => {
            props.handleLoading(false)
        }, 500)
    }

    const handleOrderStatus = (e: SdkMessage[MessageType.OrderStatus]) => { }

    const handleOnResize = (e: SdkMessage[MessageType.Resize]) => { }

    const handleOnSuccess = (e: SdkMessage[MessageType.Success]) => {
        props.onSuccess(true)
    }

    const handleOnSubmit = (e: SdkMessage[MessageType.Submit]) => {
        clickPurchaseButton('card')
    }

    const handleOnInteraction = (e: SdkMessage[MessageType.Interaction]) => { }

    const handleOnVerify = (e: SdkMessage[MessageType.Verify]) => { }

    const handleOnRedirectMessage = (e: SdkMessage[MessageType.Redirect]) => { }

    const handleOnCustomStylesAppended = (e: SdkMessage[MessageType.CustomStylesAppended]) => { }

    const handleCard = (e: SdkMessage[MessageType.Card]) => { }

    const handleOnReadyPaymentInstance = (form: ClientSdkInstance) => { }

    return (
        <>
            {merchantData && (
                <div className={cn({ 'payment-response': isFailedPayment }, 'solid-gate-form mt-6')}>
                    <Payment
                        applePayButtonParams={{
                            enabled: true,
                            color: theme === 'dark' ? 'white' : 'black',
                            type: 'pay',
                            integrationType: 'js',
                        }}
                        applePayContainerRef={appleContainerRef}
                        merchantData={merchantData}
                        styles={{
                            submit_button: {
                                'background-color':
                                    '#349760',
                                color: '#fff',
                                'border-radius': '24px',
                                'height': '48px',
                                'text-transform': 'unset',
                                'font-weight': '600',

                                '.title-icon': {
                                    display: 'none',
                                },
                                '.title': {
                                    'letter-spacing': '0',
                                },
                            },
                            input_group: {
                                'position': 'relative',
                                'width': '100%',
                                '.label': {
                                    color: '#101A36B2',
                                    'font-weight': '500',
                                    'font-size': '12px',
                                    'position': 'absolute',
                                    'left': '24px',
                                    'top': '16px',
                                    'transform': 'translateY(0)',
                                    'line-height': '16px',
                                },
                                input: {
                                    color: mainColor,
                                    'border-color': 'transparent',
                                    'border-radius': '24px',
                                    'padding': '32px 24px 14px',
                                    'height': '70px',
                                    'background': '#101A360A',
                                    'font-size': '16px',
                                    '::placeholder': {
                                        color: '#101A3666',
                                    },
                                    ':focus': {
                                        'padding': '32px 24px 14px',
                                        '::placeholder': {
                                            color: '#101A3666',
                                        },
                                    },
                                },
                                '.brand-icon': {
                                    'top': '31px',
                                },
                                '.tooltip-icon': {
                                    'top': '32px',
                                },
                                '.not-empty .label': {
                                    'font-size': '12px',
                                },
                                '.not-empty input': {
                                    'padding': '32px 24px 14px',
                                },
                                '.error input': {
                                    color: '#e46161',
                                    'padding': '32px 24px 14px',
                                    'border-color': '#e46161',
                                    '::placeholder': {
                                        color: '#e46161',
                                    },
                                },
                                '.error-text': {
                                    'font-size': '12px',
                                    'line-height': '16px',
                                    'margin-top': '4px',
                                },
                                '.error-text .triangle': {
                                    'top': '.2em',
                                }
                            },
                            'two-columns': {
                                'gap': '12px',
                                'margin': '12px 0',
                                'grid-template-columns': '1fr 1fr',
                            }
                        }}
                        formParams={{
                            submitButtonText: 'Continue',
                        }}
                        onError={handleOnError}
                        onFail={handleOnFail}
                        onCard={handleCard}
                        onMounted={handleOnMounted}
                        onOrderStatus={handleOrderStatus}
                        onResize={handleOnResize}
                        onSuccess={handleOnSuccess}
                        onSubmit={handleOnSubmit}
                        onInteraction={handleOnInteraction}
                        onVerify={handleOnVerify}
                        onFormRedirect={handleOnRedirectMessage}
                        onCustomStylesAppended={handleOnCustomStylesAppended}
                        onReadyPaymentInstance={handleOnReadyPaymentInstance}
                    />

                    <div ref={appleContainerRef} className="h-[46px]" />

                    {isFailedPayment && (
                        <div className="relative top-[-50px]">
                            {paymentError && <p className="popup-description">{paymentError}</p>}
                            <button
                                onClick={() => setIsFailedPayment(false)}
                                className="text-center max-w-[300px] block mx-auto mt-6 w-full h-14 py-2.5 px-4 rounded-4xl text-white dark:text-black bg-buttonGradient disabled:bg-buttonDisable text-L font-bold"
                            >
                                Try Again
                            </button>
                        </div>
                    )}
                </div>
            )}
        </>
    )
}
